import React from 'react'
import Footer from '../Footer/Footer'
import Header from '../Header/Header'
import Contact from './Contact'
import Hero from './Hero'

const ContactScreen = () => {
  return (
    <div>
      <Header />
      <Hero />
      <Contact />
      <Footer />
    </div>
  )
}

export default ContactScreen